import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Contractor } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseQueryOptions<unknown, Error, Contractor>,
    'queryKey' | 'queryFn'
  >;
}

export const useContractorRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<unknown, Error, Contractor>(
    [Entities.Contractors, id],
    async () => {
      const { data } = await api.v1AdminContractorsContractorIdGet(id)
      return data
    },
    { ...options },
  )
}
